import { useAppSelector } from "../../store/hooks"
import STICKER_BUSINESS_FWY from './stickers-business/STICKER_BUSINESS_FWY.png'
import STICKER_BUSINESS_BAJA from './stickers-business/STICKER_BUSINESS_BAJA.png'
import STICKER_BUSINESS_CUL from './stickers-business/STICKER_BUSINESS_CUL.png'
import STICKER_BUSINESS_VFK from './stickers-business/STICKER_BUSINESS_VFK.png'
import STICKER_BUSINESS_USA from './stickers-business/STICKER_BUSINESS_USA.png'
import STICKER_BUSINESS_INO from './stickers-business/STICKER_BUSINESS_INO.png'
import STICKER_BUSINESS_SSB from './stickers-business/STICKER_BUSINESS_SSB.png'
import STICKER_BUSINESS_SOH from './stickers-business/STICKER_BUSINESS_SOH.png'
import STICKER_BUSINESS_OAS from './stickers-business/STICKER_BUSINESS_OAS.png'
import STICKER_BUSINESS_ACC from './stickers-business/STICKER_BUSINESS_ACC.png'
import { HiOutlinePhotograph } from "react-icons/hi"
import useQueryDownloadCustom from "../../customHooks/useQueryDownloadCustom"

interface Props {
  black_white: boolean,
  id_campaign: string
}
const Stickersbussinescard = ({black_white, id_campaign}:Props) => {
  const { brand } = useAppSelector(state => state.campaign.detail)
  const { name } = useAppSelector(state => state.user)

  let imgPick: string = STICKER_BUSINESS_FWY

  console.log(brand)

  switch (brand) {
    case 'FWY':
      imgPick = STICKER_BUSINESS_FWY
      break;
    case 'BAJA':
      imgPick = STICKER_BUSINESS_BAJA
      break;
    case 'USA':
      imgPick = STICKER_BUSINESS_USA
      break;
    case 'CUL':
      imgPick = STICKER_BUSINESS_CUL
      break;
    case 'VERNFONK':
      imgPick = STICKER_BUSINESS_VFK
      break;
    case 'INO':
      imgPick = STICKER_BUSINESS_INO
      break;
    case 'SSB':
      imgPick = STICKER_BUSINESS_SSB
      break;
    case 'SOH':
      imgPick = STICKER_BUSINESS_SOH
      break;
    case 'OASIS':
      imgPick = STICKER_BUSINESS_OAS
      break;
    case 'ACC':
      imgPick = STICKER_BUSINESS_ACC
      break;
  }

  let namefile = black_white ? `qr-business-cards-black&white-${name}-${brand}` : `qr-business-cards-${name}-${brand}`

  const { isLoading, onGenerate } = useQueryDownloadCustom({ name: `${namefile.toUpperCase()}.png` })

  const onDownloadImg = () => {
    onGenerate({
      url: black_white ? '/api/purls/employee/campaigns/business-card/one-bw' : '/api/purls/employee/campaigns/business-card/one',
      params: {
        id_campaign
      },
      onComplete:(response, onDownload) => {
        onDownload(response.data.data.img)
      }
    })
  }

  return (
    <div className="c-code-qr__container">
      <div className="c-code-qr__header">
        <span className="c-code-qr__title">{black_white ? `Black & White QR Code for Business Cards` : `QR Code for Business Cards`}</span>
      </div>
      <div className="c-code-qr__content" >
        <img src={imgPick} className={`c-code-qr__img-qr ${black_white && `c-code-qr__img-bw`}`} alt="qr-campaign" />
      </div>
      <button className={`c-code-qr__button-download ${isLoading && `c-code-qr__button-download--disabled`}`} onClick={onDownloadImg}>
        {
          isLoading ?
            <>
              Download...<div className="spiner"></div>
            </>
            :
            <>
              {
                black_white ? 'Download Black & White QR Code for Business Cards' : 'Download Color QR Code'
              }<HiOutlinePhotograph />
            </>
        }
      </button>
    </div>
  )
}

export default Stickersbussinescard